module.exports = __webpack_public_path__ + "img/zwischenzeiten3.507fdd17.jpg";